/**
 * Where to go once sign-in completes. Signing in starts from the customer
 * workspace by default, so PayRight staff who asked for nothing in particular
 * land in the operations console instead; a specific page they were sent to,
 * such as one customer notice, is still honored. Only same-site paths count.
 */
export function landingAfterSignIn(requested: unknown, internal: boolean): string {
  const path = typeof requested === 'string' && requested.startsWith('/') && !requested.startsWith('//') ? requested : '/app';
  return internal && (path === '/app' || path === '/app/') ? '/ops' : path;
}
